import React from 'react'

import { Rifm } from 'rifm'
import { Input } from 'reactstrap'
import { AsYouType } from 'libphonenumber-js'

const parseDigits = string => ((string || '').match(/\d+/g) || []).join('');

const formatPhone = string => {
  const digits = parseDigits(string).substr(0, 10);
  return new AsYouType('US').input(digits);
};

export default function PhoneNumberInput({ value, onChange, placeholder, ...props }) {
  const phone = (value || '')
  const mask = phone.length < 6 && /[^\d]+/.test(phone[3]) ? undefined : phone.length >= 14

  return (
    <Rifm
      mask={mask}
      value={phone}
      accept={/\d+/g}
      format={formatPhone}
      onChange={onChange}
      placeholder={placeholder}
    >
      {({ value, onChange}) => renderInput({ placeholder, value, onChange, ...props })}
    </Rifm>
  );
};

const renderInput = ({ placeholder, value, onChange, ...props }) => (
  <Input placeholder={placeholder} value={value} onChange={onChange} {...props} />
)
